<template>
  <div class="churn-settings">
    <div class="header">
      <div>
        <h2>ภาพรวมคำนวณอัตราการเลิกเป็นลูกค้า</h2>
        <p>Churn Rate หรืออัตราการเลิกเป็นลูกค้าของคุณ คือ การที่ลูกค้าประจำของคุณ แล้วเลิกใช้และซื้อสินค้าหรือบริการ ในช่วงระยะเวลาใดเวลาหนึ่ง</p>
      </div>
      <div style="display: flex; flex-direction: column; align-items: flex-end">
        <p>แนวโน้มการสูญเสียลูกค้าแบบภาพรวม</p>
        <button @click="onClickCalButton" class="standard-formula">
          <SettingsButtonIcon /> <span>{{ !isSelectStandard ? 'Adjusted' : 'Standard' }} Formula</span>
        </button>
      </div>
    </div>
    <div class="divider" />
    <div class="source-section">
      <h3>แหล่งที่มาที่ 1 : Main Customer</h3>
      <div class="setting-group">
        <div class="setting-item" @click="onClickInside">
          <div class="setting-item-top">
            <div style="display: flex; align-items: center">
              <div class="status-icon"><ChurnedFaceIcon /></div>
              <span>Churned</span>
            </div>
            <div class="status-setting-by-source" :class="[{ active: true }, { requirbanner: false }]">
              {{ true ? 'Set' : false ? 'Required' : 'Not Set' }}
            </div>
          </div>
          <div class="des-text">ลูกค้าที่เลิกซื้อสินค้า หรือ เลิกใช้บริการธุรกิจของคุณ</div>
        </div>
        <div class="setting-item" @click="onClickInside">
          <div class="setting-item-top">
            <div style="display: flex; align-items: center">
              <div class="status-icon"><RiskChurnFaceIcon /></div>
              <span>Risk Churn</span>
            </div>
            <div class="status-setting-by-source" :class="[{ active: false }, { requirbanner: false }]">
              {{ false ? 'Set' : false ? 'Required' : 'Not Set' }}
            </div>
          </div>
          <div class="des-text">กลุ่มเสี่ยงการสูญเสียลูกค้าประจำ หรือ เลิกเป็นลูกค้า ลูกค้าไม่กลับมาซื้อสินค้า หรือใช้บริการธุรกิจของคุณซ้ำ</div>
        </div>
      </div>
    </div>
  </div>
  <div class="churn-settings-add-source">
    <div class="switch-list-churn-by-sourc-container">
      <div class="switch-list-churn-by-source">
        <input id="s-churn" type="checkbox" class="switch" v-model="switchValueChurn" @change="buildSwitchValueChurn()" />
      </div>
      <div class="text-switch-list-churn-by-source"><span> เปิดการตั้งค่าเพิ่มเติม</span></div>
    </div>
    <div v-if="switchValueChurn">
      <div class="text-description-list-churn-by-source">
        <span>การเปิดการตั้งค่า สามารถกำหนดอัตราการเลิกเป็นลูกค้าในช่วงระยะเวลาใดเวลาหนึ่งในแต่ละแหล่งที่มาของข้อมูล </span>
      </div>
      <div v-if="isLoading" class="cal-anal-overlay" />
      <div v-if="isLoading" class="cal-anal-loading-wrp" style="margin: auto"><LoadingAnimateIcon /></div>
      <div v-else>
        <div v-for="(source, index) in sourceSelect" :key="index">
          <div class="list-churn-header">
            <div class="text-list-churn-header">แหล่งที่มาที่ {{ index + 2 }} :</div>
            <div class="dropdown-list-churn-header">
              <v-select
                v-model="sourceSelect[index].dropdownValue"
                @update:modelValue="handleSelectChange(index)"
                :options="reMaindropDownSource"
                :clearable="false"
                :searchable="false"
              ></v-select>
            </div>
            <div class="button-del-list-churn-header">
              <div class="control-delete me-2">
                <button class="btn d-flex align-items-center justify-content-center" @click="onDeleteChurnBySource(index)">
                  <TrashIcon width="18px" height="20px" />
                </button>
              </div>
            </div>
          </div>
          <div class="list-churn-by-source">
            <div class="setting-item" @click="onClickInside">
              <div class="setting-item-top">
                <div style="display: flex; align-items: center">
                  <div class="status-icon"><ChurnedFaceIcon /></div>
                  <span>Churned</span>
                </div>
                <div class="status-setting-by-source" :class="[{ active: source.churned.isSet }, { requirbanner: source.churned.isRequired }]">
                  {{ source.churned.isSet ? 'Set' : source.churned.isRequired ? 'Required' : 'Not Set' }}
                </div>
              </div>
              <div class="des-text">ลูกค้าที่เลิกซื้อสินค้า หรือ เลิกใช้บริการธุรกิจของคุณ</div>
            </div>
            <div class="setting-item" @click="onClickInside">
              <div class="setting-item-top">
                <div style="display: flex; align-items: center">
                  <div class="status-icon"><RiskChurnFaceIcon /></div>
                  <span>Risk Churn</span>
                </div>
                <div
                  class="status-setting-by-source"
                  :class="[{ active: source.risk_churn.isRequired }, { requirbanner: source.risk_churn.isRequired }]"
                >
                  {{ source.risk_churn.isRequired ? 'Set' : source.risk_churn.isRequired ? 'Required' : 'Not Set' }}
                </div>
              </div>
              <div class="des-text">กลุ่มเสี่ยงการสูญเสียลูกค้าประจำ หรือ เลิกเป็นลูกค้า ลูกค้าไม่กลับมาซื้อสินค้า หรือใช้บริการธุรกิจของคุณซ้ำ</div>
            </div>
          </div>
        </div>
        <div v-if="reMaindropDownSource.length > 0" class="add-source">
          <button @click="addSource"><PlusIcon /> เพิ่มการตั้งค่าอัตราการเลิกเป็นลูกค้าในแต่ละแหล่งที่มา</button>
        </div>
      </div>
    </div>
    <div v-else></div>
  </div>

  <CalculateModal
    :is-standard="isSelectStandard"
    :is-open="isOpenCalModal"
    :loading="false"
    @close-modal="onCloseCalModal"
    @apply-modal="onClickApply"
  />
</template>

<script setup lang="ts">
import { onBeforeMount, ref, Ref, markRaw, computed } from 'vue';
import router from '@/router';
import SettingsButtonIcon from '@assets/icons/modules/analytics/churn-rate/SettingsButtonIcon.vue';
import RiskChurnFaceIcon from '@assets/icons/modules/analytics/churn-rate/RiskChurnFaceIcon.vue';
import ChurnedFaceIcon from '@assets/icons/modules/analytics/churn-rate/ChurnedFaceIcon.vue';
import TrashIcon from '@/assets/icons/modules/segment/all-segment/Trash.vue';
import useValidationModal from '@/views/components/modal/hooks/useValidationModal';
import PlusIcon from '@/assets/icons/modules/communication/template-tab/Plus.vue';
import LoadingAnimateIcon from '@/assets/icons/modules/customer-insight/LoadingAnimateIcon.vue';

const { openDefaultErrorModal, openWarningModal, openSuccessModal, openErrorModal } = useValidationModal();

import BaseButton from '@/views/components/button/BaseButton.vue';
import CalculateModal from '../../components/anal-churnrate/CalculateModal.vue';

interface Source {
  name: string;
  churned: boolean;
  riskChurn: boolean;
}

const isSelectStandard: Ref<boolean> = ref(true);
const isOpenCalModal: Ref<boolean> = ref(false);
const isLoading: Ref<boolean> = ref(false);
const switchValueChurn: Ref<boolean> = ref(true);

// const sources = ref<Source[]>([
//   { name: 'Main Customer', churned: false, riskChurn: false },
//   { name: 'ChocoCRM', churned: false, riskChurn: false },
// ]);

const dropDownSource = ref<any[]>([
  { label: 'ChocoCRM', id: 0 },
  { label: 'ChocoPOS', id: 1 },
  { label: 'Fasthelp5', id: 2 },
]);

const reMaindropDownSource = computed(() =>
  dropDownSource.value.filter((el: any) => !sourceSelect.value.map((val) => val.dropdownValue).includes(el)),
);

const sourceSelect = ref<any[]>([]);

function addSource() {
  if (reMaindropDownSource.value.length > 0) {
    sourceSelect.value.push({
      churned: { isSet: true, isRequired: false },
      risk_churn: { isSet: false, isRequired: false },
      dropdownValue: reMaindropDownSource.value[0],
    });
  }
}

function buildSwitchValueChurn() {}

function onDeleteChurn(index: number) {
  // sourceSelect
  sourceSelect.value.splice(index, 1);
  openSuccessModal(
    'ลบรายการสำเร็จ',
    '',
    '',
    () => {},
    () => {},
  );
}

function onDeleteChurnBySource(index: number) {
  openWarningModal('ยืนยันการลบการตั้งค่าอัตราการเลิกเป็นลูกค้า ของแหล่งที่มา ChocoCRM', `ต้องการยืนยันการลบ ใช่หรือไม่ ?`, () =>
    onDeleteChurn(index),
  );
}
function onClickApply(isStandard: boolean) {
  isSelectStandard.value = isStandard;
  openSuccessModal('ทำรายการสำเร็จ', '', '', undefined, () => onCloseCalModal());
}
function onClickCalButton() {
  isOpenCalModal.value = true;
}

function handleSelectChange(index: number) {
  sourceSelect.value[index];
}

function onCloseCalModal() {
  isOpenCalModal.value = false;
}

function onClickInside() {
  router.push({
    path: '/analytics/churnRate/calculateinside',
    query: {
      ...router.currentRoute.value.query,
    },
  });
}
function getData() {
  isLoading.value = true;
  setTimeout(() => {
    addSource();
    addSource();
    isLoading.value = false;
  }, 2000);
}

onBeforeMount(() => {
  getData();
});
</script>

<style lang="scss" scoped>
.control-delete {
  margin-left: 1rem;
  .btn {
    width: 43px;
    height: 43px;
    border: 1px solid #e2e2e2;
    border-radius: 8px;

    svg {
      fill: #707070;
    }

    &:hover,
    &:focus {
      background-color: #f45f5f;
      box-shadow: 0 3px 15px rgb(255 46 46 / 15%);

      svg {
        fill: #fff;
      }
    }
  }
}
//
input[type='checkbox'].switch {
  --active: #6bb84c;
  --active-inner: #fff;
  --focus: 2px #6bb84c30;
  --border: rgba(0, 0, 0, 0.25);
  --border-hover: #6bb84c;
  --background: #fff;
  --disabled: #f6f8ff;
  --disabled-inner: #e1e6f9;
  -webkit-appearance: none;
  -moz-appearance: none;
  height: 21px;
  outline: none;
  display: inline-block;
  vertical-align: top;
  position: relative;
  margin: 0;
  cursor: pointer;
  border: 1px solid var(--bc, var(--border));
  background: var(--b, var(--background));
  transition:
    background 0.3s,
    border-color 0.3s,
    box-shadow 0.2s;
  &:after {
    content: '';
    display: block;
    left: 0;
    top: 0;
    position: absolute;
    transition:
      transform var(--d-t, 0.3s) var(--d-t-e, ease),
      opacity var(--d-o, 0.2s);
  }
  &:checked {
    --b: var(--active);
    --bc: var(--active);
    --d-o: 0.3s;
    --d-t: 0.6s;
    --d-t-e: cubic-bezier(0.2, 0.85, 0.32, 1.2);
  }
  &:disabled {
    --b: var(--disabled);
    cursor: not-allowed;
    opacity: 0.9;
    &:checked {
      --b: var(--disabled-inner);
      --bc: var(--border);
    }
    & + label {
      cursor: not-allowed;
    }
  }
  &:hover {
    &:not(:checked) {
      &:not(:disabled) {
        --bc: var(--border-hover);
      }
    }
  }
  &:focus {
    box-shadow: 0 0 0 var(--focus);
  }
  & + label {
    font-size: 14px;
    line-height: 21px;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
    margin-left: 4px;
  }
}
input[type='checkbox'].switch {
  width: 38px;
  border-radius: 11px;
  &:after {
    left: 2px;
    top: 2px;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    background: var(--ab, var(--border));
    transform: translateX(var(--x, 0));
  }
  &:checked {
    --ab: var(--active-inner);
    --x: 17px;
  }
  &:disabled {
    &:not(:checked) {
      &:after {
        opacity: 0.6;
      }
    }
  }
}
.churn-settings {
  width: 100%;
  min-height: 430px;
  padding: 30px;
  gap: 30px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      //styleName: H2;
      font-family: Prompt;
      font-size: 20px;
      font-weight: 500;
      line-height: 30.24px;
      text-align: left;
      color: #000000;
    }
    p {
      //styleName: SH1;
      font-family: Prompt;
      font-size: 16px;
      font-weight: 400;
      line-height: 24.19px;
      text-align: left;
      color: #00000078;
    }
    :deep(.standard-formula) {
      max-width: 200px;
      padding: 8px 16px 8px 16px;
      gap: 8px;
      border-radius: 10px;
      background: #ffffff;
      border: 1px solid #007fff;
      cursor: pointer;
      path {
        stroke: #007fff;
      }
      span {
        color: #007fff;
      }
      &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      }
    }
  }

  .divider {
    margin-top: 2rem;
    margin-bottom: 2rem;
    width: 100%;
    height: 1px;
    background: #e2e2e2;
  }
  .source-section {
    margin-top: 24px;

    h3 {
      //styleName: H5;
      font-family: Prompt;
      font-size: 18px;
      font-weight: 400;
      line-height: 27.22px;
      text-align: left;

      margin-bottom: 2rem;
    }

    .setting-group {
      display: flex;
      margin-top: 8px;
      width: 100%;
      min-height: 152px;
      gap: 32px;

      .setting-item {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        width: 400px;
        padding: 24px;
        gap: 24px;
        border-radius: 20px;
        background: #ffffff;
        border: 1px solid #e2e2e2;
        cursor: pointer;
        .setting-item-top {
          display: flex;
          width: 100%;
          justify-content: space-between;
          align-items: center;

          span {
            font-family: Prompt;
            font-size: 20px;
            font-weight: 500;
            line-height: 24.42px;
            text-align: left;
            color: #2d2d2d;
            margin-left: 1rem;
          }

          .status-setting-by-source {
            min-width: 75px;
            height: 29px;
            padding: 4px 16px 4px 16px;
            gap: 8px;
            border-radius: 16px;
            background: #f3f3f3;
            display: flex;
            justify-content: center;
            align-items: center;
            &.active {
              background: #e5f2ff;
              color: #007fff;
            }
          }
          .status-icon {
            width: 34px;
            height: 34px;
            gap: 0px;
            border-radius: 50%;
          }
        }
        .des-text {
          //styleName: Text Lig 14;
          font-family: Prompt;
          font-size: 14px;
          font-weight: 400;
          line-height: 21.17px;
          text-align: left;
          color: #646464;
        }
        &:hover {
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
}

.churn-settings-add-source {
  width: 100%;
  padding: 2rem;
  gap: 24px;
  border-radius: 10px;
  background: #ffffff;
  margin-top: 1rem;
  margin-bottom: 5rem;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  .cal-anal-overlay {
    margin-top: 5rem;
  }
  .switch-list-churn-by-sourc-container {
    display: flex;
    .switch-list-churn-by-source {
    }
    .text-switch-list-churn-by-source {
      margin-left: 1rem;
      span {
        //styleName: Text Reg 16;
        font-family: Prompt;
        font-size: 16px;
        font-weight: 400;
        line-height: 24.19px;
        text-align: left;
        color: #000000;
      }
    }
  }
  .text-description-list-churn-by-source {
    margin-top: 1rem;
    span {
      //styleName: Text Lig 14;
      font-family: Prompt;
      font-size: 16px;
      font-weight: 400;
      line-height: 21.17px;
      text-align: left;
      color: #606a6c;
    }
  }
  .list-churn-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 30rem;
    margin-top: 2rem;
    .text-list-churn-header {
      //styleName: H5;
      font-family: Prompt;
      font-size: 18px;
      font-weight: 400;
      line-height: 27.22px;
      text-align: left;
    }
    .dropdown-list-churn-header {
      font-family: Prompt;
      font-size: 16px;
      font-weight: 400;
      line-height: 1;
      text-align: left;
      color: #2d2d2d;
      display: block;
      width: 250px;
      background-color: #fff;
      background-clip: padding-box;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      transition:
        border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
      letter-spacing: 0.031rem;
      margin-left: 1rem;
      border-radius: 10px;
      &:deep(.vs__dropdown-toggle) {
        border: 1px solid #e2e2e2;
        border-radius: 10px;
        height: 42px;
      }

      .vs__selected-options {
        position: relative;
        height: 100%;
      }

      .v-select {
        width: 100%;

        .vs__dropdown-toggle {
          height: 100%;

          .vs__selected {
            position: absolute;
            height: 100%;
            margin: auto auto auto 0;
          }
        }
      }
    }
    .button-del-list-churn-header {
    }
  }
  .list-churn-by-source {
    margin-top: 2rem;
    display: flex;
    width: 100%;
    min-height: 152px;
    gap: 32px;

    .setting-item {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      width: 400px;
      padding: 24px;
      gap: 24px;
      border-radius: 20px;
      background: #ffffff;
      border: 1px solid #e2e2e2;
      cursor: pointer;
      .setting-item-top {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;

        span {
          font-family: Prompt;
          font-size: 20px;
          font-weight: 500;
          line-height: 24.42px;
          text-align: left;
          color: #2d2d2d;
          margin-left: 1rem;
        }

        .status-setting-by-source {
          min-width: 75px;
          height: 29px;
          padding: 4px 16px 4px 16px;
          gap: 8px;
          border-radius: 16px;
          background: #f3f3f3;
          display: flex;
          justify-content: center;
          align-items: center;
          &.active {
            background: #e5f2ff;
            color: #007fff;
          }
          &.requirbanner {
            background: #ff4f4433;
            color: #ff4f44;
          }
        }
        .status-icon {
          width: 34px;
          height: 34px;
          gap: 0px;
          border-radius: 50%;
        }
      }
      .des-text {
        //styleName: Text Lig 14;
        font-family: Prompt;
        font-size: 14px;
        font-weight: 400;
        line-height: 21.17px;
        text-align: left;
        color: #2d2d2d;
      }
      &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      }
    }
  }
  .add-source {
    margin-top: 2rem;

    button {
      width: 100%;
      height: 62px;
      padding: 16px;
      gap: 8px;
      border: 0; /* เอาขอบออก */
      border-radius: 8px;
      padding: 10px;
      background-color: #eff7ff;
      background-image: linear-gradient(to right, #0072e5 55%, rgba(255, 255, 255, 0) 0%),
        linear-gradient(to bottom, #0072e5 55%, rgba(255, 255, 255, 0) 0%), linear-gradient(to left, #0072e5 55%, rgba(255, 255, 255, 0) 0%),
        linear-gradient(to top, #0072e5 55%, rgba(255, 255, 255, 0) 0%);
      background-size:
        20px 2px,
        2px 20px,
        20px 2px,
        2px 20px;
      background-position:
        top left,
        top right,
        bottom right,
        bottom left;
      background-repeat: repeat-x, repeat-y, repeat-x, repeat-y;
      cursor: pointer;
      //styleName: H3;
      font-family: Prompt;
      font-size: 18px;
      font-weight: 400;
      line-height: 30.24px;
      text-align: center;
      color: #007fff;

      svg {
        fill: #007fff;
        width: 15px;
        height: 15px;
      }
    }
  }
}
</style>

<!-- <template>
  <div class="card-body-container">
    <base-button class="button-item" @on-click="onClickCalButton">
      <template v-slot:prepend>
        {{ 'set' }}
      </template>
    </base-button>
  </div>
  <div class="card-body-container"></div>
  <div class="card-body-container"></div>
  <CalculateModal :is-open="isOpenCalModal" :loading="false" @close-modal="onCloseCalModal" />
</template>
<script setup lang="ts">
import { onBeforeMount, ref, Ref, markRaw } from 'vue';
import BaseButton from '@/views/components/button/BaseButton.vue';

import CalculateModal from '../../components/anal-churnrate/CalculateModal.vue';
const isOpenCalModal: Ref<boolean> = ref(false);

function onClickCalButton() {
  isOpenCalModal.value = true;
}

function onCloseCalModal() {
  isOpenCalModal.value = false;
}
</script>

<style lang="scss" scoped>
.card-body-container {
  width: 100%;
  border-radius: 20px;
  min-height: 20rem;
  margin-bottom: 1rem;
  background-color: #fff;
}
</style> -->
